// Invite system user (routes/invites.js): the link is /invite/<token>, the token 32 random bytes in base64url.
const INVITE_PATH = /^\/invite\/([A-Za-z0-9_-]{43})\/?$/

export function inviteTokenIn(pathname: string): string | null {
  const m = INVITE_PATH.exec(pathname)
  return m ? m[1] : null
}

export const isInvitePath = (pathname: string) => pathname.startsWith('/invite/')

// What taking up the link came to, once signed in. ok: the workspace is theirs now (or already was).
export interface InviteOutcome {
  ok: boolean
  message?: string
}
